(() => {
  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return false;
    drawer.open(document.activeElement);
    return true;
  }

  function openAfterAdd() {
    let attempts = 0;
    const tryOpen = () => {
      attempts += 1;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && !drawer.classList.contains('is-empty')) {
        openCartDrawer();
        return;
      }
      if (attempts < 20) setTimeout(tryOpen, 150);
    };
    tryOpen();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('[data-type=\"add-to-cart-form\"]')) return;
    const productForm = form.closest('product-form');
    if (!productForm) return;
    setTimeout(openAfterAdd, 350);
  }, true);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'product-form') setTimeout(openAfterAdd, 100);
    });
  }
})();